/**
 * Storefront API
 * ---
 * Details for Storefront API.
 */

const storefrontAccessToken = {
  dev: '5293d63e3d57d4a4247d664868c8471c',
  prod: '6741e02b5e59d5f60044ac301ccc62ff'
};

function getAccessToken() {
  return Shopify.shop == 'annathomas-dev.myshopify.com' ? storefrontAccessToken.dev : storefrontAccessToken.prod;
}

export const requestConfig = {
  headers: {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': getAccessToken()
  }
};